import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiService } from '@/services/api/ApiService';

export const useCheckSubscriptionStatus = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (subscriptionId: string) => {
      const result = await ApiService.callEdge<{ success: boolean; newStatus?: string }>("stripe-handler", {
        action: "checkSubscriptionStatus",
        subscriptionId,
      });
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["subscription"] });
      queryClient.invalidateQueries({ queryKey: ["users-with-subscriptions"] });
      console.log("Subscription status checked and updated");
    },
    onError: (error: Error) => {
      console.error("Error checking subscription status:", error);
    },
  });

  return {
    checkSubscriptionStatus: (subscriptionId: string) => mutation.mutateAsync(subscriptionId),
    isChecking: mutation.isPending,
    error: mutation.error,
  };
};
